










import { Vue, Component } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class Todo extends Vue {
  bread = [{ name: '客户旅程指标分析驾驶仓' }, { name: '自助指标分析' }];
}
